import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import Svg from '../svgIcon';

const PagerArrow = ({ disabled, onArrowClick, iconName }) => (
    <button
        className={
            classNames(
                'bs-btn',
                'bs-btn_major',
                'bs-pager__arrow',
                { 'bs-pager__arrow_disabled': disabled },
            )
        }
        onClick={onArrowClick}
    >
        <Svg
            className={
                classNames(
                    'bs-pager__arrowIcon',
                    { 'bs-pager__arrow_disabled': disabled },
                )
            }
            size="Medium"
            iconName={iconName}
        />
    </button>
);

PagerArrow.defaultProps = {
    disabled: false,
};

PagerArrow.propTypes = {
    onArrowClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    iconName: PropTypes.string.isRequired,
};

export default PagerArrow;



// WEBPACK FOOTER //
// /src/js/common/pager/PagerArrow.jsx